import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-88bdf23a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "text-center"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-check text-success",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_3 = { class: "fullscreen-modal__title" }
const _hoisted_4 = { class: "mt-3" }
const _hoisted_5 = {
  key: 1,
  class: "text-center"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-close text-danger",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_7 = { class: "fullscreen-modal__title" }
const _hoisted_8 = { class: "text-center container-narrow mt-5" }
const _hoisted_9 = { class: "row justify-content-center" }
const _hoisted_10 = { class: "col-md-4 col-6" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "col-md-4 col-6" }
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_LoadingSpinner, { loading: _ctx.isLoading }, null, 8, ["loading"]),
    (_ctx.successData.success)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.successData.message), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.successData.ticketCount) + " " + _toDisplayString(_ctx.successData.ticketCount > 1 ? _ctx.translate('shop.configuration.tickets') : _ctx.translate('shop.configuration.ticket')), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.successData.message), 1)
        ])),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("a", {
            href: _ctx.cartUrl,
            class: "btn btn-dark btn-lg d-block success-btn"
          }, _toDisplayString(_ctx.translate('shop.configuration.cart')), 9, _hoisted_11)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("a", {
            href: _ctx.checkoutUrl,
            class: "btn btn-tertiary btn-lg d-block success-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clickCheckoutButton()))
          }, _toDisplayString(_ctx.translate('shop.configuration.checkout')), 9, _hoisted_13)
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("a", {
          href: _ctx.continueUrl,
          class: "btn btn-link"
        }, _toDisplayString(_ctx.translate('shop.configuration.continue-shopping')), 9, _hoisted_15)
      ])
    ])
  ], 64))
}